//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import { mapGetters } from "vuex";
import { VALIDATE_INFO } from "../../store/mutation-types";
export default {
  name: "ValidateCommentPage",
  components: { HiHeader },
  computed: {
    ...mapGetters({
      form: VALIDATE_INFO,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/pages/validate/Comment.vue